import { render, staticRenderFns } from "./person_by_appointment_list.vue?vue&type=template&id=5b125225"
import script from "./person_by_appointment_list.vue?vue&type=script&lang=js"
export * from "./person_by_appointment_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports